export default __webpack_public_path__ + "static/share-context-dark-3d62d30df006b325cc12cfd97eef9232.png";